import React, { useEffect, useContext, useState } from "react";
import AppContext from "../contexts/AppContext";
import { useHistory } from "react-router";
import { readProjects, setProject, setProjectMemberships } from "../actions";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CustomBox from "./templates/customBox";
import componentStyles from "../assets/styles/components/sidebar_project_list";
import { SidebarProjectListItem } from "./sidebar_project_list_item";

import { useTranslation } from "react-i18next";
const useStyles = makeStyles(componentStyles);

const SidebarProjectList = (props) => {
  const { setAnchorEl } = props;
  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const errors = {};
  const redmineurl = state.current.redmineurl;
  const apikey = state.current.apikey;
  const classes = useStyles();

  useEffect(() => {
    async function getCurrentAuthenticatedUser() {
      if (redmineurl) {
        setLoading(true);
        await readProjects(redmineurl, apikey, dispatch);
        setLoading(false);
      }
    }
    getCurrentAuthenticatedUser();
  }, [state.current.redmineurl, state.siteConfigs]);

  return (
    <>
      <CustomBox loading={loading} errors={errors}>
        <List className={classes.listRoot}>
          <ListItemAll setAnchorEl={setAnchorEl} />
          <SidebarProjectListItem
            projects={state.projects}
            setAnchorEl={setAnchorEl}
          />
        </List>
      </CustomBox>
    </>
  );
};

const ListItemAll = (props) => {
  const { setAnchorEl } = props;
  const { state, dispatch } = useContext(AppContext);
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  const handleClickResetProjectButton = async () => {
    await setProjectMemberships(dispatch, []);
    await setProject(dispatch, { project: {} });
    if (setAnchorEl) setAnchorEl(null);
    history.push("/project/issues");
  };

  return (
    <ListItem
      button
      onClick={(e) => handleClickResetProjectButton()}
      className={classes.listItemRoot}
      selected={
        !state.current.project || !Object.keys(state.current.project).length
      }
    >
      <ListItemText
        className={classes.listItemText}
        primary={
          <Typography style={{ fontSize: "0.85rem" }}>
            {t("label_all")}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default SidebarProjectList;
